import React from 'react';

function Card({name, icon, text, link}) {
    let delay = (name.length - 1) * 100;
    delay = delay.toString();
    
    return (
        <div className="card" data-aos="fade-up" data-aos-delay={delay}>
            <div className="card__icon">
                <img src={icon} alt={name} />
            </div>

            <div className="card__info">
                <p className="card__info__name">{name}</p>
                <p className="card__info__text">{text}</p>
            </div>
        </div>
    );
}

export default Card



// WEBPACK FOOTER //
// ./src/Components/Technologies/JavaScript/Card.js